import gql from 'graphql-tag';

import cardDetails from '../fragments/cardDetails';

const getPrintProductsForCardDesigner = gql`
  query getPrintProductsForCardDesigner($print_partner_id: RecordID) {
    printProducts(
      print_partner_id: $print_partner_id
      is_standard: true
      slice: { limit: 1 }
    ) {
      total
      records {
        id
        name
        is_standard
        print_partner {
          id
          name
        }
        card {
          ...cardDetails
        }
        sizes(slice: { limit: 99 }) {
          total
          records {
            id
            print_size {
              id
              name
              width
              height
            }
            price {
              value
              currency
            }
            min_price {
              value
              currency
            }
            total_price {
              value
              currency
            }
            orientations
          }
        }
        print_size {
          id
          name
          width
          height
        }

        preview_asset_image {
          id
          url
        }
      }
    }
  }
  ${cardDetails}
`;

export default getPrintProductsForCardDesigner;
